import { render, staticRenderFns } from "./CatgList.vue?vue&type=template&id=69449c5f&scoped=true&"
import script from "./CatgList.vue?vue&type=script&lang=js&"
export * from "./CatgList.vue?vue&type=script&lang=js&"
import style0 from "./CatgList.vue?vue&type=style&index=0&id=69449c5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69449c5f",
  null
  
)

export default component.exports